import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogActions, Grid, FormControl, Typography } from '@mui/material';
import { FlightCard } from 'models/flight-card.interface';
import { Address } from 'views/Restaurant/SelectedCellMap';

interface ActivateFlightCardRouteDialogProps {
  modalOpen: boolean;
  onClose: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
  flightCard: FlightCard;
  address: Address;
  aircraft: string;
  handleClose: Function;
  udpateFlightCardActive: Function;
  addFlightCard: Function;
  checked: boolean;
}

export default function ActivateFlightCardRouteDialog({
  modalOpen,
  onClose,
  flightCard,
  address,
  aircraft,
  handleClose,
  udpateFlightCardActive,
  addFlightCard,
  checked
}: Readonly<ActivateFlightCardRouteDialogProps>) {
  const enableOrDisableTextDependingOnActiveStatus = checked ? 'enable' : 'disable';

  function handleYes() {
    if (checked) {
      addFlightCard({
        orderId: address.orderId,
        note: address.eircode,
        flightType: 'VOLUME_TESTING',
        aircraft: aircraft,
        noOfFlights: 10000,
        count: 1,
        active: true,
        route: address.eircode
      }).then(res => {
        handleClose();
      });
    } else {
      udpateFlightCardActive(flightCard.id, checked).then(res => {
        flightCard.active = checked;
        handleClose();
      });
    }
  }

  function handleNo() {
    handleClose();
  }

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={modalOpen}
      BackdropProps={{ style: { backgroundColor: 'transparent' } }}
      PaperProps={{
        style: {
          margin: '10px 0px',
          width: '100%',
          maxWidth: 500,
          top: '70%'
        }
      }}
      style={{
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        height: '30%',
        maxHeight: 700,
        margin: 'auto'
      }}
    >
      <DialogContent dividers>
        <FormControl fullWidth style={{ left: -12, maxHeight: 300 }}>
          <Typography
            variant="h2"
            style={{
              wordWrap: 'break-word',
              width: '100%',
              maxWidth: '100%',
              textAlign: 'center'
            }}
          >
            Are you sure you want to {enableOrDisableTextDependingOnActiveStatus} "
            {flightCard ? flightCard.route : address?.eircode}" on aircraft "
            {flightCard ? flightCard.aircraft : aircraft}"?
          </Typography>
        </FormControl>
      </DialogContent>
      <DialogActions style={{ alignContent: 'center' }}>
        <Grid container>
          <Button
            onClick={() => handleYes()}
            style={{ margin: 10, left: '30%' }}
            variant="contained"
            color="primary"
          >
            <Typography variant="h2" style={{ color: '#FFFFFF' }}>
              Yes
            </Typography>
          </Button>
          <Button
            onClick={() => handleNo()}
            style={{ margin: 10, left: '30%' }}
            variant="contained"
            color="primary"
          >
            <Typography variant="h2" style={{ color: '#FFFFFF' }}>
              No
            </Typography>
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
